<p>bad browser (private mode possibly?), or something else bad, very bad</p>
<p>add extensive explanation of the problem, if in private mode, the order could not be saved (on local!)</p>
